import { observer } from 'mobx-react-lite';

// components
import { AppSpacer } from 'components/ui';
import { AppSwitch } from 'components/form';

// types
import { IOrganizationLicense } from 'types/models/OrganizationModels';

export const LicenseManagerComponent = observer(
({
    allLicenses,
    organizationLicenses,
    isLoading,
    onUpdate,
}: {
    allLicenses: IOrganizationLicense[];
    organizationLicenses: string[];
    isLoading: boolean;
    onUpdate: (licenses: string) => void;
}) => {
    return (
        <section>
            <h3 className='font-15 font-700 font-lato text-capitalize mr-2 line-height-23'>
                <span className='mr-2'>Licenses</span>
            </h3>

            <AppSpacer space='15px' />

            {allLicenses.map((license, index) => (
                <div className='card p-2' key={`${index}`}>
                    <AppSwitch
                        name={license.key}
                        title={license.key}
                        isReversed={false}
                        width={'100'}
                        isDisabled={isLoading}
                        onChange={(e) => { onUpdate(license.key); }}
                        isChecked={organizationLicenses.some((f) => f === license.key)}
                        classNames='justify-content-between'
                        color='primary'
                    />
                    <AppSpacer space='5px' />
                    
                    <h3 className='font-13 font-700 font-lato text-capitalize mr-2 line-height-23 text-underline'>
                        <span className='mr-2'>Features</span>
                    </h3>
                    
                    <div className='row w-100'>
                        {license.features.map((feature, fIndex) => (
                            <p className='font-10 font-700 font-lato text-capitalize col-sm-auto flex-column color-secondaryGrey' key={`${fIndex}`}>
                                {feature}
                            </p>
                        ))}
                    </div>
                </div>
            ))}
        </section>
    );
});